import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("导出")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_button, {
    loading: _ctx.loading,
    onClick: _ctx.onExport,
    type: _ctx.btnType,
    disabled: _ctx.selectedIds.length === 0
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_1
      ])
    ]),
    _: 3
  }, 8, ["loading", "onClick", "type", "disabled"]))
}